/* eslint-disable class-methods-use-this */
import * as Yup from 'yup';
import { History } from 'history';
import { Dispatch } from 'redux';
import { TcsmEpiApiState } from '../../../../../../root/tcsm-model';
import { InstitutionProps } from '../../../../models/arc-epi-props';
import { OePlanOffer, OePlanOfferings } from '../../institution-model';
import { PlanAdoptionWizard } from '../../plan-adoption/wizards/plan-adoption-wizard';
import { DeclineMedicalDentalFormModel, DeclineMedicalDentalSubmitModel } from '../models';
import { TiersTypes } from '../../../new-hire-enrollment/enrollment/models/coverage-models';
import { getCurrencyFormat } from '../../../../../../global/helpers/format-helpers';
import { getCurrentTimeNY } from '../../../../../../global/helpers/date-helpers';
import { getOePlanOffering, postOePlanOffering } from '../../../../../../global/ducks/mlps-api';
import { setOePlanOfferings } from '../../institution-slice';
import { PensionPlanTypes } from '../../plan-history/plan-history-models';


export class DeclineMedicalDentalWizard extends PlanAdoptionWizard {

	onSubmit: any;

	readonly oePlanOfferings: OePlanOfferings;

	readonly successUrl: string;

	constructor(dispatch: Dispatch<any>, history: History<unknown>, epiContent: TcsmEpiApiState, oePlanOfferings: OePlanOfferings, successUrl: string) {
		super(dispatch, history, epiContent);
		this.oePlanOfferings = oePlanOfferings;
		this.onSubmit = this.declineSubmit;
		this.successUrl = successUrl;
	}

	getFormContentModel(): InstitutionProps {
		return this?.epiContent?.institutionSettingsState?.epiContent;
	}


	getFormValidationSchema() {
		return Yup.object().shape({
			medical: this.oePlanOfferings?.medical?.length > 0 ? Yup.array().min(1, this?.epiContent?.institutionSettingsState?.epiContent?.atLeastOnePlanRequiredMessage).required(this?.epiContent?.institutionSettingsState?.epiContent?.atLeastOnePlanRequiredMessage) : null,
			dental: this.oePlanOfferings?.dental?.length > 0 ? Yup.array().min(1, this?.epiContent?.institutionSettingsState?.epiContent?.atLeastOnePlanRequiredMessage).required(this?.epiContent?.institutionSettingsState?.epiContent?.atLeastOnePlanRequiredMessage) : null,
		});
	}

	getFormInitialValue(): DeclineMedicalDentalFormModel {
		return {
			medical: this?.oePlanOfferings?.medical?.filter(a => !a?.optout)?.map(plan => plan?.plan_code),
			dental: this?.oePlanOfferings?.dental?.filter(a => !a?.optout)?.map(plan => plan?.plan_code),
		};
	}

	planHasTier(plan: OePlanOffer, tier: TiersTypes) {
		return plan?.tiers?.find(a => a?.tier === tier);
	}

	getRateDisplay(plan: OePlanOffer, tier: TiersTypes) {

		const rate = plan?.tiers?.find(a => a?.tier === tier)?.rate;

		return rate ? getCurrencyFormat(rate) : null;
	}

	onCancel(url: string) {
		this.history.push(url);
	}

	getCurrentYear() {
		return getCurrentTimeNY()?.getFullYear() + 1;

	}

	getGroupInfo() {
		const plan = this?.oePlanOfferings?.medical[0];
		return {
			name: plan?.group_name,
			id: plan?.group_id,
		};
	}

	createSubmitModel(values: DeclineMedicalDentalFormModel) {
		const medicalOptOut = this?.oePlanOfferings?.medical?.filter(plan => !values?.medical?.includes(plan?.plan_code)).map(plan => { return { plan_code: plan?.plan_code, group_id: plan.group_id }; });
		const dentalOptOut = this?.oePlanOfferings?.dental?.filter(plan => !values?.dental?.includes(plan?.plan_code)).map(plan => { return { plan_code: plan?.plan_code, group_id: plan.group_id }; });

		return {
			optouts: {
				plans: medicalOptOut?.concat(dentalOptOut),
			},
		};
	}

	declineSubmit(request: DeclineMedicalDentalSubmitModel) {
		const payload = this.createSubmitModel(request?.values);
		this.dispatch(postOePlanOffering(
			request?.institutionId,
			payload,
			() => {
				this.dispatch(getOePlanOffering(request?.institutionId, (res) => this.dispatch(setOePlanOfferings(res?.data))));
				this.history.push(`${this.successUrl}?formType=${PensionPlanTypes.OePlans}`);
			},
		));
	}

	getPlusOneLabel(plan: OePlanOffer) {
		if (!this.planHasTier(plan, TiersTypes.EmpPlusChild) && !this.planHasTier(plan, TiersTypes.EmpPlusMulti)) {
			return this.getFormContentModel().tier2Label;
		}
		return this.getFormContentModel().tier3Label;
	}
}